import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider } from './contexts/AuthContext'
import { LibraryProvider } from './contexts/LibraryContext'
import { CatalogProvider } from './contexts/CatalogContext'
import { BackendProvider } from './contexts/BackendContext'
import { ErrorBoundary } from './components/ErrorBoundary'
import './styles.css'
import './dark.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode><ErrorBoundary><BrowserRouter><AuthProvider><BackendProvider><CatalogProvider><LibraryProvider><App/></LibraryProvider></CatalogProvider></BackendProvider></AuthProvider></BrowserRouter></ErrorBoundary></StrictMode>
)
